import React from 'react';
import { Box, Text } from '@chakra-ui/core';
import { Cell } from 'react-table';
import { CandidateSearchResponseType } from '../CandidateSearchTypes';
import { getConsistentDateFormat } from '../../../utils/dateUtils';

interface LastUpdatedAtCellProps {
  cell: Cell<CandidateSearchResponseType>;
}

export const LastUpdatedAtCell: React.FC<LastUpdatedAtCellProps> = ({ cell }) => {
  const { statusDetails } = cell.row.original;
  return (
    <Box>
      <Text fontSize="14px">{getConsistentDateFormat(statusDetails?.lastUpdatedAt, 'full')}</Text>
    </Box>
  );
};
